import React from 'react';
import { LocalPageTemplate } from '../components/LocalPageTemplate';
export function WebdesignHoornPage() {
  return <LocalPageTemplate cityName="Hoorn" region="West-Friesland" introText="Een professionele website voor jouw bedrijf in Hoorn. Wij bouwen websites die de ambitie van West-Friese ondernemers weerspiegelen: betrouwbaar, resultaatgericht en onderscheidend." localContext="Hoorn is het kloppend hart van West-Friesland en trekt als historische havenstad zowel toeristen als zakelijke bezoekers. Met een groeiend centrum vol horeca, retail en dienstverleners is online zichtbaarheid essentieel. Of je nu een winkel hebt aan de Grote Noord of een kantoor op Hoorn 80 — wij zorgen dat klanten uit de regio jou vinden." nearbyLocations={[{
    name: 'Enkhuizen',
    slug: 'enkhuizen'
  }, {
    name: 'Stede Broec',
    slug: 'stede-broec'
  }, {
    name: 'Drechterland',
    slug: 'drechterland'
  }, {
    name: 'Koggenland',
    slug: 'koggenland'
  }]} faqs={[{
    q: 'Wat kost een website laten maken in Hoorn?',
    a: 'Een professionele website voor een ondernemer in Hoorn begint vanaf €1.500. Afhankelijk van je wensen (webshop, reserveringssysteem, uitgebreide SEO) kan de prijs variëren. We maken altijd een offerte op maat.'
  }, {
    q: 'Bouwen jullie ook websites voor horeca in Hoorn?',
    a: 'Zeker. Hoorn heeft een bloeiende horecascene en wij hebben ruime ervaring met websites voor restaurants, cafés en hotels. Denk aan online menukaarten, reserveringssystemen en sfeervolle fotografie.'
  }, {
    q: 'Hoe zorgen jullie dat ik gevonden word in West-Friesland?',
    a: 'We optimaliseren je website specifiek voor lokale zoektermen in Hoorn en West-Friesland. Daarnaast helpen we met je Google Bedrijfsprofiel zodat je ook op Google Maps prominent zichtbaar bent voor klanten in de regio.'
  }]} data-id="element-2046" />;
}